namespace RioERP.Orders {
    export interface BrandAmbassadorPaymentsRow {
        Id?: number;
        BrandAmbassadorId?: number;
        PaymentDate?: string;
        PaidAmount?: number;
        PaymentMode?: Web.Enums.PaymentMode;
        Remark?: string;
        PaymentRefNo?: string;
        BankName?: string;
        Comment?: string;
        ReceiptNo?: string;
        IsActive?: number;
        BrandAmbassadorName?: string;
        BrandAmbassadorDescription?: string;
        BrandAmbassadorEmail?: string;
        BrandAmbassadorAlternateEmail?: string;
        BrandAmbassadorMobile?: string;
        BrandAmbassadorAlternateMobile?: string;
        BrandAmbassadorAddress?: string;
        BrandAmbassadorCity?: string;
        BrandAmbassadorStateId?: number;
        BrandAmbassadorUserId?: number;
        BrandAmbassadorGstin?: string;
        BrandAmbassadorPan?: string;
        BrandAmbassadorGstCertificate?: string;
        BrandAmbassadorBankName?: string;
        BrandAmbassadorBankAccountType?: number;
        BrandAmbassadorBankAccountName?: string;
        BrandAmbassadorBankAccountNo?: string;
        BrandAmbassadorBankIfscCode?: string;
        BrandAmbassadorPincode?: number;
        BrandAmbassadorIsActive?: boolean;
        BrandAmbassadorInsertUserId?: number;
        BrandAmbassadorInsertDate?: string;
        BrandAmbassadorUpdateUserId?: number;
        BrandAmbassadorUpdateDate?: string;
        BrandAmbassadorCustomerId?: number;
        BrandAmbassadorDiscountCoupon?: string;
        RowIds?: string;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace BrandAmbassadorPaymentsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Remark';
        export const localTextPrefix = 'Orders.BrandAmbassadorPayments';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            BrandAmbassadorId = "BrandAmbassadorId",
            PaymentDate = "PaymentDate",
            PaidAmount = "PaidAmount",
            PaymentMode = "PaymentMode",
            Remark = "Remark",
            PaymentRefNo = "PaymentRefNo",
            BankName = "BankName",
            Comment = "Comment",
            ReceiptNo = "ReceiptNo",
            IsActive = "IsActive",
            BrandAmbassadorName = "BrandAmbassadorName",
            BrandAmbassadorDescription = "BrandAmbassadorDescription",
            BrandAmbassadorEmail = "BrandAmbassadorEmail",
            BrandAmbassadorAlternateEmail = "BrandAmbassadorAlternateEmail",
            BrandAmbassadorMobile = "BrandAmbassadorMobile",
            BrandAmbassadorAlternateMobile = "BrandAmbassadorAlternateMobile",
            BrandAmbassadorAddress = "BrandAmbassadorAddress",
            BrandAmbassadorCity = "BrandAmbassadorCity",
            BrandAmbassadorStateId = "BrandAmbassadorStateId",
            BrandAmbassadorUserId = "BrandAmbassadorUserId",
            BrandAmbassadorGstin = "BrandAmbassadorGstin",
            BrandAmbassadorPan = "BrandAmbassadorPan",
            BrandAmbassadorGstCertificate = "BrandAmbassadorGstCertificate",
            BrandAmbassadorBankName = "BrandAmbassadorBankName",
            BrandAmbassadorBankAccountType = "BrandAmbassadorBankAccountType",
            BrandAmbassadorBankAccountName = "BrandAmbassadorBankAccountName",
            BrandAmbassadorBankAccountNo = "BrandAmbassadorBankAccountNo",
            BrandAmbassadorBankIfscCode = "BrandAmbassadorBankIfscCode",
            BrandAmbassadorPincode = "BrandAmbassadorPincode",
            BrandAmbassadorIsActive = "BrandAmbassadorIsActive",
            BrandAmbassadorInsertUserId = "BrandAmbassadorInsertUserId",
            BrandAmbassadorInsertDate = "BrandAmbassadorInsertDate",
            BrandAmbassadorUpdateUserId = "BrandAmbassadorUpdateUserId",
            BrandAmbassadorUpdateDate = "BrandAmbassadorUpdateDate",
            BrandAmbassadorCustomerId = "BrandAmbassadorCustomerId",
            BrandAmbassadorDiscountCoupon = "BrandAmbassadorDiscountCoupon",
            RowIds = "RowIds",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
